import { render, staticRenderFns } from "./giftCoupon.vue?vue&type=template&id=4b9e0907&scoped=true"
import script from "./giftCoupon.vue?vue&type=script&lang=js"
export * from "./giftCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e0907",
  null
  
)

export default component.exports